import React from 'react';
import { Grid, MenuItem } from '@mui/material';
import { TSecureDataZone, useZone } from '../../contexts/ZoneContext';
import { SdzMenuOption } from './DataZoneMenuOption';
import { SdzSelectorHeading } from './DataZoneSelectorHeading';
import { styles as realmInputStyle } from '../RealmInput.helper';
import { LifeGraphByBurstIQIcon } from '../../../assets';
import { styles as sdzStyle } from './data-zone-selector-helper';
import { Button, CircularProgress } from '@biq/apex-ui';
import { useAuth } from 'core/contexts';
import { useNavigate } from 'react-router-dom';

// This is the one that happens on login
export const DataZoneSelector = (): React.JSX.Element => {
    const { avaliableSecureDataZones, setSelectedDataZone, zonesLoading } =
        useZone();
    const { logout } = useAuth();
    const navigate = useNavigate();
    const isSecureDataZoneEmpty: boolean =
        avaliableSecureDataZones?.length === 0 ||
        avaliableSecureDataZones === null;

    const handleEnvironmentClick = (env: TSecureDataZone): void => {
        setSelectedDataZone(env);
    };

    const onClickLogout = (): void => {
        const url = new URL(window.location.href);
        url.searchParams.delete('realm');
        navigate(url.pathname + url.search, { replace: true });
        logout();
    };

    const getZonesData = (): React.JSX.Element => {
        if (isSecureDataZoneEmpty) {
            return (
                <Grid sx={sdzStyle.sdzImageAndLogoutButtonContainer}>
                    <Button size='large' onClick={onClickLogout}>
                        Logout
                    </Button>
                </Grid>
            );
        } else {
            return (
                <>
                    <Grid sx={sdzStyle.sdzSelectorOptionContainer}>
                        {React.Children.toArray(
                            avaliableSecureDataZones?.map(
                                (env: TSecureDataZone) => (
                                    <MenuItem
                                        sx={sdzStyle.sdzMenuItem}
                                        onClick={(): void =>
                                            handleEnvironmentClick(env)
                                        }
                                    >
                                        <SdzMenuOption env={env?.name} />
                                    </MenuItem>
                                )
                            )
                        )}
                    </Grid>
                    <Grid sx={sdzStyle.sdzLogoutButtonContainer}>
                        <Button size='large' onClick={onClickLogout}>
                            Logout
                        </Button>
                    </Grid>
                </>
            );
        }
    };

    return (
        <Grid container sx={realmInputStyle.mainContainer}>
            <Grid
                item
                sx={{
                    ...sdzStyle.sdzContainer,
                    p: isSecureDataZoneEmpty
                        ? '77px 79.65px 385px 79.65px'
                        : '77px 61px 147px 61px',
                }}
            >
                <Grid
                    container
                    direction={'column'}
                    sx={realmInputStyle.formContainer}
                >
                    <Grid sx={sdzStyle.sdzImageAndLogoutButtonContainer}>
                        <img
                            src={LifeGraphByBurstIQIcon}
                            alt='icon'
                            style={sdzStyle.sdzImage}
                        />
                    </Grid>
                    <SdzSelectorHeading
                        zonesLoading={zonesLoading}
                        isSecureDataZoneEmpty={isSecureDataZoneEmpty}
                    />

                    {zonesLoading ? (
                        <Grid
                            display={'flex'}
                            justifyContent={'center'}
                            width={'100%'}
                        >
                            <CircularProgress variant='indeterminate' />
                        </Grid>
                    ) : (
                        getZonesData()
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};
